import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-大于",
  "use": "icon-大于-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-大于\"><path d=\"M383.156706 237.327059c15.661176-15.661176 41.140706-15.661176 56.801882 0l240.941177 240.941176c15.661176 15.661176 15.661176 41.080471 0 56.741647l-240.941177 240.941177a40.176941 40.176941 0 1 1-56.801882-56.801883L595.727059 506.639059 383.096471 294.068706a40.176941 40.176941 0 0 1 0-56.801882z\" fill=\"#101820\" fill-opacity=\".6\" p-id=\"2403\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol